export default {
    header: {
        hello:
            "Hello, welcome to the online website of Early Childhood Multilingual Education",
        serve: "Service hotline",
        login: "Login",
        zhuce: "Registration",
        en: "en",
        zh: "zh"
    },
    indexNav: {
        index: "Home",
        peixun: "Training",
        kaoshi: "registration",
        about: "About",
        input: "Input key",
        reict: "Employment",
        base: "Project cooperation"
    },
    rightNav: {
        question: "Registration consultation",
        common: "Official Account",
        qiye: "Enterprise cooperation",
        top: "Top floor"
    },
    indexVideo: {
        intro1:
            "Professional competence training courses for multilingual preschool teachers",
        phone: "Phone",
        address: "Address",
        intro222: "Work dynamics",
        li: "development history",
        li2: "Policy announcement",
        intro2:
            "It is a new, systematic and complete preschool education mode that helps children to recognize the world, develop intelligence and perfect personality, and realize comprehensive, healthy and happy growth"
    },
    indexClass: {
        intro1:
            "Professional competence training courses for multilingual preschool teachers",
        intro2:
            'Through a series of courses, students will be equipped with the multilingual application ability, MTRP education method and intelligent device operation ability in accordance with the "Characteristic Competence Standard for Multi-lingual Teachers"',
        intro3: "Purchase of Training Courses",
        intro4: "Online Registration Test"
    },
    indexSchool: {
        intro1: "Multilingual kindergarten"
    },
    footer: {
        news: "News information",
        phone: "Customer Service  Hotline",
        monday: "Monday to Friday",
        email: "Email address",
        address:
            "Address: No.6, Yujiayuan South Street, Huairou District, Beijing",
        serve: "The service agreement",
        help: "Get help",
        agreement: "User agreement",
        concat: "Contact us",
        href: "Link: Huajia international multilingual",
        danwei:
            "Advocate unit: Preschool Education Professional Committee of China Private Education Association",
        china:
            "China Youth concern committee Health and Physical Cultue Development Center",
        create:
            "Research and development unit：Children’s Multilingual Education Research Center of the Academic Committee of China Academy of Management sciences",
        code:
            "Copynight @ 2012-2019 Beijing Multilingual Education Co., LtdSouMate  All  Rights  Reserved Beijing ICP no.19000971-1 Jinggong Anbei no.31010702004489",
        add1: "主办机构：中国关心下一代工作委员会健体心",
        add2: " 研发机构：中国管理科学研究院学术委员会儿童多语教育研究中心",
        add3:
            "推广机构：中国关心下一代工作委员会健体中心儿童多语发展计划管理委员会"
    },
    teacher: {
        sayClass: "Language Course",
        openClass: "Open Courses",
        Package: "Premium Package",
        Multilingual: "Multilingual language courses",
        game: "Theme Game Course",
        toy: "Technology Intelligent Toy Operation",
        Introduction: "Course Introduction",
        note: "Purchase Notes",
        Catalogue: "Course Catalogue",
        recommendation: "recommendation",
        buy: "Buy now",
        yuanprice: "Original Price",
        disPrice: "Discount Price",
        teacherjie: "Lecturer Introduction",
        classNum: "Class hour",
        classType: "Class type",
        look: "Look more"
    },
    teacherBuy: {
        cancelOrder: "Course Order Confirmation",
        five:
            "Please complete the payment within 15 minutes, otherwise the order will be automatically cancelled",
        orderInfo: "Order Information",
        classInfo: "Course Information",
        orderNum: "Order Number",
        orderTime: "Order time",
        classNum: "Number of courses",
        payType: "Payment Method",
        detail: "Actually paid",
        payTime: "Pay immediately",
        codePay: "Scan to pay",
        baomin: "Enrollment Examination Information Confirmation",
        info: "personal information",
        name: "Name",
        addrress: "Location",
        getPe: "consignee",
        onePic: "One inch photo",
        time: "Examination time",
        type: "Examination type",
        min: "min"
    },
    personalCenter: {
        personNum: "Modify personal account number",
        info: "Basic information",
        userName: "Usename",
        yesInfo: "Real name information",
        sex: "Gender",
        nan: "male",
        nv: "female",
        card: "ID number",
        pleaseCard: "Please fill in your ID number",
        telePhone: "Contact number",
        address: "Mailing address",
        changePassword: "Change Password",
        submit: "Submit",
        phone: "Mobile phone number ",
        code: "Verification Code",
        getCode: "get verification code",
        inputPass: "Enter new password ",
        commitPass: "confirm new password",
        yes: "Confirm modification",
        cancel: "cancel",
        yeses: "determine",
        bindPhone: "Binding mobile phone number",
        logout: "Log Out",
        tools: "Common tools",
        myOrder: "My orders",
        myKaoshi: "My exam",
        myExam: "My certificates",
        moreClass: "More courses"
    },
    centerOrder: {
        address: "Your current location",
        orderNum: "Order number",
        orderInfo: "Order information",
        orderTime: "Order time",
        orderType: "Order type",
        orderMoney: "Order amount",
        orderStatus: "Order status"
    },
    examCenter: {
        none:
            "Your examination qualification has not been found yet. You can only take the examination after filling in the registration form",
        myExam: "My exam",
        nowSign: "Sign up now"
    },
    invoice: {
        openInvo: "Invoicing",
        yesorNo: "Issue an invoice or not",
        paper: "Paper invoice",
        eleinvo: "Electronic invoice",
        invoHeader: "Beginning of invoice",
        personel: "individual",
        compony: "company",
        invoContent: "Invoice content",
        getPeple: "Addressee",
        phone: "Contact number",
        address: "Detailed address",
        apply: "To apply for open"
    },
    infoCenter: {
        all: "All",
        yesRead: "Mark all as read"
    },
    classes: {
        num: "Class",
        video: "Video",
        audio: "Audio",
        book: "Text",
        none: "none",
        all: "All",
        len: "Multilingual",
        teach: "method",
        toy: "科技智能玩具操作"
    },
    addClass: {
        intro1:
            "Multilingual kindergarten teacher’s grade examination is held on Wednesdays...",
        intro2:
            "《Certificate of multilingual kindergarten teachers》 Grade examination is approved...",
        detail: "Detail>>",
        time: "Examination date"
    },

    recruit: {
        picture: "Company Album ",
        concat: "Contact information",
        info: "Company basic information",
        money: "Salary Requirements",
        choose: "Please select",
        serchAddress: "Search address",
        serchZhiwei: "Search for job position",
        serch: "Search",
        jieshao: "Company profile",
        job: "Job description"
    },
    aboutUs: {
        type: "contents of a project",
        teacher: "Multilingual teachers",
        center: "Research center",
        concatUs: "Contact us",
        question: "Common questions",
        newCenter: "News Center",
        job: "Job recommendation",
        see: "See more jobs",
        intro1: "Focus on multilingual training, one entrance examination ...",
        intro2:
            "《Certificate of multilingual kindergarten teachers》，Please select the level of the certificate",

        aaaa1: "Project background",
        aaaa2: "Project introduction",
        aaaa3: "Project value",
        aaaa4: "Entry Body", //30

        type9: "Brand cooperation", //3
        type10: "Certificate cooperation", //9
        type11: "Textbook cooperation", //10
        type12: "Base cooperation", //31
        type13: "Declaration process" //32
    }
};



// WEBPACK FOOTER //
// ./src/common/lang/en.js